import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";


interface IProps extends BaseCardProps {
  baseUrl: string;
  data: any;
  config: SiteConfig_siteConfig_dashboardConf_components;
}


const PaintShopCard: FunctionComponent<IProps> = memo(function PaintShop({ data, config, ...rest }) {
  const intl = useIntl();

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__paint_shop____title",
        defaultMessage: `{count, plural,
          one {Paint Shop}
          other {Paint Shops}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      image={"/images/svg/lakovna.svg"}
    >
        <StatsTable
          inline
          rows={[
            {
              label: intl.formatMessage({
                id: "dashboard__paint_shop__kw",
                defaultMessage: "Active power",
              }),
              unit: "kW",
              decimals: 2,
              // type: "number",
              value: data?.active_power,
            },
          ]}
        />
    </BaseCard>
  );
}, isEqual);

export default PaintShopCard;
